/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "{738F7F14-5142-476F-85C0-D358C335A11D}",
  "sitecoreApiHost": "https://www.ghac.cn/",
  "jssAppName": "portal-website",
  "app": {
    "term": "prod",
    "apiHost": "/api/honda/v1/",
    "deployUrlS3": "https://media.ghac.cn/s",
    "mall": "https://mall.ghac.cn/"
  },
  "dmp": {
    "accord": {
      "vgPre": {
        "act": "xRX_J8LsawXtILGCNb3124bzHjkg.FFt633",
        "drive": "x_pHw8kiawXtILGCNb3124bAOHd.qqstB0"
      }
    },
    "breeze": {
      "vgPre": {
        "act": "xRX_J8LsawboWmmqNfkAkG8As2f.CJH5Z3",
        "drive": "x_pHw8kiawboWmmqNfkAkGm1sy.6m5wO"
      }
    },
    "enp1": {
      "vgPre": {
        "act": "xRX_J8Lsawwy2jbtcUw0HD.pDH83a",
        "drive": "x_pHw8kiawwy2jbtc000.MkpGAa"
      }
    },
    "": {
      "vgPre": {
        "act": "xRX_J8LsawkAUmmtcUw0HD.cZMfE3",
        "drive": "x_pHw8kiaw8ofIUPU0wVEr.HD62na"
      }
    },
    "integra": {
      "vgPre": {
        "act": "xRX_J8Lsaw6KN-GHcaZ.8DonS0",
        "drive": "x_pHw8kiaw6KN-GYkcZ.cwj6u"
      }
    },
    "z": {
      "vgPre": {
        "act": "xRX_J8Lsa2OoTYGHcam3.FtP1k0",
        "drive": "x_pHw8kia2OoTYGYkcZ.9pSELa"
      }
    },
    "odyssey": {
      "vgPre": {
        "act": "xRX_J8Lsaw06dI8vNc_2t5_hH6UXzM.kCxZX3",
        "drive": "x_pHw8kiaw06dI8vNc_2t5_hHXXX.wCLVs3"
      }
    },
    "avancier": {
      "vgPre": {
        "act": "xRX_J8LsawXCIm0YdUUDkG8As2f.n0ONG",
        "drive": "x_pHw8kiawXCIm0YdUUDkGm1sy.-kMbI0"
      }
    },
    "crider": {
      "vgPre": {
        "act": "xRX_J8LsawRofmwP5hXP5BUQ.lK2kF3",
        "drive": "x_pHw8kiawRofmwP5hXh65f.bxojJ3"
      }
    },
    "fit": {
      "vgPre": {
        "act": "xRX_J8LsawmPN-GHcam3.OhVGYa",
        "drive": "x_pHw8kiawmPN-GYkcZ.AD5sJ"
      }
    }
  },
  "h5": {
    "url": "https://ghac.realibox.com/api/customer/api/v1/applet/generatescheme"
  },
  "defaultLanguage": "zh-cn",
  "graphQLEndpointPath": "/sitecore/api/graph/edge",
  "graphQLEndpoint": "https://www.ghac.cn//sitecore/api/graph/edge"
};